export default __webpack_public_path__ + "static/media/book_2.91be9802.svg";